import type { RoomMode as PanelMode } from "@/components/camp/RoomModePicker";
import type { RoomMode } from "@/engine/state/roomControl";

/**
 * Plainest first: the two that can be recognised before the two that have to
 * be tried, and Campfire — what the product is about — last, so it does not
 * read as a choice already made.
 */
export const MODES: readonly RoomMode[] = [
  "plain",
  "teams",
  "bubbles",
  "campfire",
];

/** The brandbook's name for each mode. */
export const PANEL_MODE: Record<RoomMode, PanelMode> = {
  plain: "plain",
  teams: "teams",
  bubbles: "bubbles",
  campfire: "fire",
};

/** And back again, for the press. */
export const APP_MODE: Record<PanelMode, RoomMode> = {
  plain: "plain",
  teams: "teams",
  bubbles: "bubbles",
  fire: "campfire",
};
